import BaseService from '@/services/BaseService';

const SUBSCRIPTIONS_PATH = 'analytics/email-subscriptions';

export type AnalyticsEmailSubscriptionWrite = {
  name: string;
  pageId: string;
  contentItemIds: string[];
  frequency: 'Daily' | 'Weekly' | 'Monthly';
  businessDaysOnly: boolean;
  dayOfWeek?: number | null;
  dayOfMonth?: number | null;
  localTime: string;
  timeZoneId: string;
  recipients: string[];
  cc: string[];
  isEnabled: boolean;
};

/**
 * Host facade for the Analytics email page. aga-frontend does not lazy-load remote services,
 * so this is the instance `useService('analyticsEmailService')` receives inside the dashboard remote.
 */
export class AnalyticsEmailService extends BaseService {
  constructor() {
    super('/api/digitalconnect-service');
  }

  fetchCatalog = () => this.get({ path: `${SUBSCRIPTIONS_PATH}/catalog` });

  fetchSubscriptions = () => this.get({ path: SUBSCRIPTIONS_PATH, params: { _: Date.now() } });

  createSubscription = (body: AnalyticsEmailSubscriptionWrite) => this.post({ path: SUBSCRIPTIONS_PATH, body });

  updateSubscription = (id: string, body: AnalyticsEmailSubscriptionWrite) =>
    this.put({ path: `${SUBSCRIPTIONS_PATH}/${id}`, body });

  deleteSubscription = (id: string) => this.delete({ path: `${SUBSCRIPTIONS_PATH}/${id}` });

  sendDraftTest = (body: AnalyticsEmailSubscriptionWrite) => this.post({ path: `${SUBSCRIPTIONS_PATH}/test`, body });

  sendTest = (id: string) => this.post({ path: `${SUBSCRIPTIONS_PATH}/${id}/test` });

  searchRecipients = (query: string) =>
    this.get({
      path: 'entra/users',
      params: { q: query, top: 5 },
      baseUrl: '/api/authorization-service',
    });
}
